import React from "react";
import {getCharacterDatabaseData} from "../includes/axios/getCharacterDatabaseData.js";
import "./pagination.css";
import { withRouter } from 'react-router-dom';
import {Provider, connect} from "react-redux";
import { BrowserRouter, Route, browserHistory, Switch, Link, Router} from "react-router-dom";
import { createBrowserHistory } from 'history';

var Pagination = class Pagination extends React.Component{
    
    constructor(props) {
        super(props);
        this.changeCharacterDatabase = this.props.changeCharacterDatabase;
        this.showCharacterDatabase = this.props.showCharacterDatabase;
        this.changePaginationOffset = this.props.changePaginationOffset;
        this.changeCharacterLetter = this.props.changeCharacterLetter;
        getCharacterDatabaseData(this.props.pagination.currentLetter,this.props.pagination.currentOffset,this.props.changeCharacterDatabase,this.props.showCharacterDatabase,this.props.changePaginationOffset,this.props.changeCharacterLetter);
        this.props.changePaginationPage(this.props.pagination.currentPage);
    }  
    


    componentDidMount(){
                   
    }//end componentDidMount()
    
    componentDidUpdate(prevProps){
        if(this.props.characterDatabase.readyToShowCharacters === true){


        }
         
    }  

    //not the same as switchPageNumber() in alpabet.js. Slightly different
    switchPageNumber(currentPage,offset){
        
        getCharacterDatabaseData(this.props.pagination.currentLetter,offset,this.props.changeCharacterDatabase,this.props.showCharacterDatabase,this.props.changePaginationOffset,this.props.changeCharacterLetter);
        this.props.changePaginationPage(currentPage);

       
    }



    render() {
      const inlineStyle = {
        
      }
      const routeBase = localStorage.getItem("routeBase"); 
     // console.log("CURRENT PAGE: " + this.props.pagination.currentPage);  

      if(this.props.characterDatabase.readyToShowCharacters === true){
        var paginationIndex = this.props.characterDatabase.characterDatabaseList.length -1;
        var paginationData = this.props.characterDatabase.characterDatabaseList[paginationIndex];

        return (
            <div className="paginationWrapper">
                <div className="paginationContainer" ref = {'paginationContainer'}>
                    {
                    paginationData.map(function(button,index){
                            //this is a shit hack bc for the life of me the routing params idea isnt working
                            //when you click one of these pagination links, its uses redux to track the Current page
                            //so on the component reload, we have the correct page.
                            //if that currentPage value is the same as the button value, add the 'highlighted' class
                            if(this.props.pagination.currentPage === button[0]){
                                var urlParam = routeBase + "/characterDatabase/page" + button[0];
                                return <Link to={urlParam} key={index} >
                                <div className={'paginationButton highlighted' } key={index} ref = {"pagination" + button[0]} id = {"pagination" + button[0]}
                                onClick = {()=>{this.switchPageNumber(button[0],button[1]);}}
                                >
                                    {button[0]}
                                </div>
                                </Link>
                            }
                            else{
                                var urlParam = routeBase + "/characterDatabase/page" + button[0];

                                return <Link to={urlParam} key={index} >
                                <div className={'paginationButton' } key={index} ref = {"pagination" + button[0]} id = {"pagination" + button[0]}
                                onClick = {()=>{this.switchPageNumber(button[0],button[1]);}}
                                >
                                    {button[0]}
                                </div>
                                </Link>
                            }
                    },this)
                    }
                </div>
            </div>
        );//return
      }//end if()
      else{
          return null;
      }
    }//end render()




  }//end class

  export default Pagination;


// WEBPACK FOOTER //
// ./src/components/pagination/Pagination.js